import { render, staticRenderFns } from "./EventChip.vue?vue&type=template&id=b9eb5eec"
import script from "./EventChip.vue?vue&type=script&lang=js"
export * from "./EventChip.vue?vue&type=script&lang=js"
import style0 from "./EventChip.vue?vue&type=style&index=0&id=b9eb5eec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports